import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { toast } from "sonner";
import { useState, useEffect } from "react";
import { Form } from "../shared/Form";
import { getShowBankAccount, updateBankAccountData } from "@/Api/bankAccounts";
import { TableDataProps } from "@/pages/BankAccounts";

interface UpdateBtnProps {
  uuid: string;
  updateFront: (data: TableDataProps) => void;
}

export function UpdateBtn({ uuid, updateFront }: UpdateBtnProps) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState<TableDataProps | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const { data } = await getShowBankAccount(uuid);
      setInitialValues(data?.response);
    } catch (error) {
      console.error(error);
      toast.error("Erro ao carregar dados!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchData();
    }
  }, [open]);

  const handleSubmit = async (values: any) => {
    try {
      setLoading(true);

      const payload = {
        name: values?.name,
        surname: values?.surname,
        bank_id: values?.bank_id,
        agency: values?.agency,
        account_number: values?.account_number,
        bank_account_type_id: values?.bank_account_type_id,
        unity_id: values?.unity_id,
      };

      const { data, ok } = await updateBankAccountData(uuid, payload);

      if (ok) {
        toast.success(data?.message || "Conta bancária atualizada com sucesso!");

        if (updateFront) {
          updateFront(data.response);
        }

        setOpen(false);
      }
    } catch (error) {
      console.error(error);
      toast.error("Ocorreu um erro ao processar sua solicitação.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="size-7 p-0 text-slate-900 hover:bg-stone-950/10 dark:text-[#F4F4F5]"
        >
          <Pencil className="size-5" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[600px]">
        {initialValues && (
          <Form
            title="Atualizar Conta Bancária"
            loading={loading}
            onSubmit={handleSubmit}
            buttonText="Atualizar"
            initialValues={initialValues}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
